import { useContext } from "react";
import { UserContext } from "../context/UserContext";
import { Outlet, Navigate, useLocation } from "react-router-dom";
import NavBar from "../components/NavBar";
import { isLoggedInUserInfo } from "./AuthState";
import { loginPathWithNext } from "./postLoginPath";

function ProtectedRoutes() {
  const { userInformation } = useContext(UserContext);
  const location = useLocation();
  const isLoggedIn = isLoggedInUserInfo(userInformation);

  return isLoggedIn ? (
    <>
      <NavBar />
      <Outlet />
    </>
  ) : (
    <Navigate to={loginPathWithNext(location.pathname)} replace />
  );
}

export default ProtectedRoutes;
